import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./Theme";
import './i18n';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "./cmp/page/NotFound";
import PageLayout from "./cmp/page/PageLayout";
import { useCmsData } from "./hooks/useCmsData";
import CmsArticlePage from "./cms/cmp/CmsArticlePage";
import LoadingSpinner from "./cmp/page/LoadingSpinner";
import CmsPage from "./cms/cmp/CmsPage";
import LoginProvider from "./context/LoginProvider";

function App() {
  const [data, loading, error] = useCmsData<Array<{"_id": string, relativeUrl: string, language: ("de" | "en")}>>({docType: "page", fields: `_id,relativeUrl,language`});
  return (
    <LoginProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <div>
            {!loading && !error && !!data && <BrowserRouter>
              <Routes>
                <Route path="/" element={<PageLayout />}>
                {data?.map(page => <Route key={`${page?.relativeUrl}`} path={`${page?.relativeUrl}`} element={page["_id"] ? <CmsPage key={`cms_page_${page?.["_id"]}`} id={page["_id"]} language={page.language} /> : <></>} />)}
                <Route path="/de">
                  <Route path="artikel/:articleId" element={<CmsArticlePage language="de" />} />
                </Route>
                <Route path="/en">
                  <Route path="article/:articleId" element={<CmsArticlePage language="en" />} />
                </Route>
                <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>}
            {loading && <BrowserRouter>
              <Routes>
                <Route path="/" element={<PageLayout />} />
                <Route path="*" element={<LoadingSpinner />} />
              </Routes>
            </BrowserRouter>}
        </div>
    </ThemeProvider>
    </LoginProvider>
  );
}

export default App;
